import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular'; // <--- PASTIKAN INI ADA
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true, 
  imports: [IonicModule, CommonModule], // <--- DAN INI WAJIB ADA
})
export class AppComponent {
  constructor() {}
}